
import { yupResolver } from "@hookform/resolvers/yup"
import { removeGidPrefix } from '@unlikelystudio/commerce-connector'
import { useForm, type UseFormProps } from "react-hook-form"
import { object, string, type InferType } from "yup"
import { backInStockSubsribe } from '~/lib/handle-api'
import { useGoogleReCaptcha } from '~/providers/RecaptchaProvider/use-google-recaptcha'

const schema = object().shape({
  email: string().required().email().trim(),
  variantId: string(),
  productId: string(),
  redirectLink: string(),
})

type FormValues = InferType<typeof schema>

export default function useStockAlertPopin(formOptions?: UseFormProps, onSuccess?: any, onError?: any, onLoading?: any) {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const form = useForm<FormValues>({
    resolver: yupResolver(schema),
    ...formOptions,
  })

  const stockAlertRegister = ({
    email,
    redirectLink,
    variantId,
    productId,
  }: {
    email: string
    redirectLink: string
    variantId: string
    productId: string
  }) => {


    const payload = {
      email,
      products: [
        {
          epi: removeGidPrefix(variantId),
          empi: removeGidPrefix(productId),
          du: redirectLink,
        },
      ],
    }

    return backInStockSubsribe({ payload })
  }

  const onSubmit = form.handleSubmit(async ({ email, variantId, redirectLink, productId }) => {
    const response = await executeRecaptcha("stockAlert")


    if (response) {
      stockAlertRegister({
        email,
        redirectLink,
        variantId,
        productId,
      }),
        onSuccess()
    } else {

      onError()
    }
  })

  return { form, onSubmit }
}
